export default __webpack_public_path__ + "static/media/pdf-icon.113e76c2.svg";